import {DifficultyCategory, UserClimbingEvent} from "../../../../models/UserClimbingEvent";
import {ClimbingEvent} from "../../../../models/ClimbingEvent";
import {FC, useState} from "react";
import {Box} from "@mui/system";
import {UserBasicData, UserDetailsForm} from "../../../user/UserDetailsForm";
import {Sex, UserData} from "../../../../models/UserData";
import {Button, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {createNewUserEvent} from "../../../../services/events/UserEventService";
import {createUserDataDocument} from "../../../../services/events/UserDataEventService";

type Props = {
  event: ClimbingEvent,
  postCreate: (userEvent: UserClimbingEvent) => void
}
export const CreateNewUser: FC<Props> = ({event, postCreate}) => {
  const {t} = useTranslation();
  const [userBasicData, setUserBasicData] = useState<UserBasicData>({name: "", birthYear: 1990, sex: Sex.MALE})
  const [isSaving, setSaving] = useState(false)
  const [error, setError] = useState<string>()

  const onChange = ((userBasicData: UserBasicData) => {
    setUserBasicData(userBasicData)
  })

  const saveIfValuesAreNotEmpty = () => {
    if (userBasicData?.name && userBasicData?.birthYear > 0 && userBasicData?.sex) {
      setSaving(true)

      const userData = new UserData(
        "GUEST_"+event.name+"_"+userBasicData.name.replace(" ","_"),
        userBasicData.name,"",
        userBasicData.birthYear,userBasicData.sex,[event.name])

      const u = new UserClimbingEvent(
        event.name,
        event.type,
        userData.uid,
        userData.name,
        userData.email,
        userData.birthYear,
        userData.sex,
        [],
        0,
        0,
        DifficultyCategory.LIGHT,
        false,
        "",
        undefined);
      createUserDataDocument(userData).then(() => createNewUserEvent(u).then(() => postCreate(u)))
    } else {
      setError(t('user.fillAllFields') || "error")
    }
  }
  return (
    <Box component="form" sx={{display: "flex", alignItems: "center", flexDirection: "column",}}>
      <Typography align="center" variant="h4">{t('user.yourData')}</Typography>
      <UserDetailsForm userBasicData={userBasicData} onChange={onChange} setError={setError} error={error} />
      <Button variant="contained" disabled={isSaving} sx={{mt: 2, p: 2, pr: 4, pl: 4}}
              onClick={() => saveIfValuesAreNotEmpty()}>{t('save')}</Button>
      <Typography color="error" sx={{display: "block", mt: 2}}>{error || ""}</Typography>
      <Typography>{isSaving ? t("saving") : ""}</Typography>
    </Box>
  )
}